import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "../../api/client";
import endpoints from "../../api/endpoints";
import { PageSpinner } from "../../components/ui/Spinner";
import useApiQuery from "../../hooks/useApiQuery";
import { useAuth } from "../auth/AuthContext";

const fieldClass =
  "block w-full rounded-lg border border-gray-600 bg-[#afafaf] p-2.5 text-sm text-[#1E1E1E] placeholder-[#1E1E1E] focus:border-blue-500 focus:ring-blue-500 disabled:opacity-80";

const ProfileTab = () => {
  const { data, loading } = useApiQuery(endpoints.profileUpdate());
  const [form, setForm] = useState({ firstName: "", lastName: "", phone: "" });
  const [editing, setEditing] = useState(false);
  const [message, setMessage] = useState(null);
  const firstNameRef = useRef(null);
  const navigate = useNavigate();
  const { logOut } = useAuth();

  useEffect(() => {
    if (!data) return;
    setForm({
      firstName: data.first_name ?? "",
      lastName: data.last_name ?? "",
      phone: (data.phone ?? "").replace("+98", "0"),
    });
  }, [data]);

  const update = (field) => (event) =>
    setForm((prev) => ({ ...prev, [field]: event.target.value }));

  const toggleEdit = async () => {
    if (!editing) {
      setEditing(true);
      setTimeout(() => firstNameRef.current?.focus(), 0);
      return;
    }

    try {
      await client.put(endpoints.profileUpdate(), {
        first_name: form.firstName,
        last_name: form.lastName,
      });
      setMessage({ text: "آپدیت پروفایل موفق بود!", type: "success" });
    } catch (error) {
      console.error("Profile update failed:", error);
      setMessage({ text: "لطفا دوباره تلاش کنید", type: "error" });
    }
    setEditing(false);
  };

  const handleLogout = () => {
    logOut();
    navigate("/", { replace: true });
  };

  if (loading) return <PageSpinner />;

  return (
    <div className="px-4 py-6 sm:px-6 md:px-8 lg:px-10">
      <label
        htmlFor="phone"
        className="mb-2 block text-sm font-medium text-white"
      >
        شماره تلفن
      </label>
      <input
        id="phone"
        type="text"
        className={fieldClass}
        value={form.phone}
        placeholder="شماره تلفن"
        disabled
      />

      <label
        htmlFor="firstName"
        className="mb-2 mt-8 block text-sm font-medium text-white"
      >
        نام
      </label>
      <input
        id="firstName"
        type="text"
        ref={firstNameRef}
        className={fieldClass}
        placeholder="نام خود را وارد کنید"
        disabled={!editing}
        value={form.firstName}
        onChange={update("firstName")}
      />

      <label
        htmlFor="lastName"
        className="mb-2 mt-8 block text-sm font-medium text-white"
      >
        نام خانوادگی
      </label>
      <input
        id="lastName"
        type="text"
        className={fieldClass}
        placeholder="نام خانوادگی خود را وارد کنید"
        disabled={!editing}
        value={form.lastName}
        onChange={update("lastName")}
      />

      <div className="mt-6 flex w-full flex-col items-center">
        <button
          type="button"
          onClick={toggleEdit}
          className="mb-4 rounded-lg bg-blue-500 px-4 py-2 text-xl text-white transition hover:bg-blue-600"
        >
          {editing ? "اتمام ویرایش" : "ویرایش اطلاعات"}
        </button>
        <button
          type="button"
          onClick={handleLogout}
          className="rounded-lg bg-red-500 px-4 py-2 text-xl text-white transition hover:bg-red-600"
        >
          خروج
        </button>
        {message && (
          <p
            className={`mt-4 text-sm ${
              message.type === "success" ? "text-green-500" : "text-red-500"
            }`}
          >
            {message.text}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProfileTab;
